/* PLAGARY 1.3.1. Native forms and server-rendered money remain authoritative. */
(() => {
  'use strict';
  // Small state primitives are also exercised directly by the isolated race tests.
  function receipts(schedule = setTimeout, cancel = clearTimeout) {
    const owners = new WeakMap();
    return {
      begin(button, show) {
        const old = owners.get(button); if (old) cancel(old.timer);
        const owner = {}; owners.set(button, owner); show('Adding…', false); return owner;
      },
      finish(button, owner, show, success) {
        if (owners.get(button) !== owner || !button.isConnected) return;
        show(success ? 'Added' : 'Add', success);
        if (success) owner.timer = schedule(() => {
          if (owners.get(button) === owner && button.isConnected) show('Add', false);
        }, 1800);
      }
    };
  }
  function deadline(work, schedule = setTimeout, cancel = clearTimeout) {
    const controller = new AbortController(); let timer;
    const timeout = new Promise((_, reject) => {
      timer = schedule(() => { controller.abort(); reject(new Error('We could not confirm this update.')); }, 15000);
    });
    return Promise.race([Promise.resolve().then(() => work(controller.signal)), timeout]).finally(() => cancel(timer));
  }
  async function changeOnce(io) {
    try {
      try { io.apply(await io.post()); }
      catch {
        try { io.apply(await io.read()); io.recovered(); }
        catch { io.unknown(); }
        return;
      }
      io.confirmed();
    } finally { io.settled(); }
  }
  function searchState() {
    let version = 0;
    return {invalidate: () => ++version, current: token => token === version};
  }
  function plainLink(event, link) {
    return !event.defaultPrevented && event.button === 0 && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey &&
      (!link.target || link.target === '_self') && !link.hasAttribute('download');
  }
  function nextSuggestion(index, length, direction) {
    return direction === 'ArrowDown' ? (index + 1 >= length ? -1 : index + 1) : (index < 0 ? length - 1 : index - 1);
  }
  if (typeof document === 'undefined') {
    if (typeof module === 'object') module.exports = {receipts, deadline, changeOnce, searchState, plainLink, nextSuggestion};
    return;
  }
  if (window.__plagaryStorefront) return;
  window.__plagaryStorefront = true;
  const configNode = document.getElementById('cf-routes');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const $ = (selector, root = document) => root?.querySelector(selector);
  const $$ = (selector, root = document) => [...(root?.querySelectorAll(selector) || [])];
  const dialogSupported = typeof HTMLDialogElement !== 'undefined' && 'showModal' in HTMLDialogElement.prototype;
  if (!dialogSupported) document.documentElement.classList.add('no-dialog');
  const openers = new WeakMap(), initialized = new WeakSet();
  let cartBusy = false, searchTimer, searchController, cartSession = 0, searchFrame;
  const added = receipts(), search = searchState();
  const announce = message => { const el = $('#cf-live'); if (el) el.textContent = message; };
  const cartDialog = () => $('#CartDrawer');
  function openDialog(dialog, trigger) {
    if (!dialogSupported || !dialog) return false;
    openers.set(dialog, trigger || document.activeElement);
    if (!dialog.open) { try { dialog.showModal(); } catch { return false; } }
    return true;
  }
  function closeDialog(dialog) {
    if (dialog?.open) { if (dialog === cartDialog()) cartSession++; dialog.close(); }
  }
  function variantFor(form) {
    const section = form?.closest('[data-product-section]');
    if (!section) return null;
    const variants = JSON.parse($('[data-variants]', section)?.textContent || '[]');
    return variants.find(v => String(v.id) === $('[name="id"]', form)?.value) || null;
  }
  function labelButton(button, label) {
    const text = [...button.childNodes].find(node => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
    if (text) text.textContent = label + ' ';
    else button.prepend(document.createTextNode(label + ' '));
  }
  function syncButtons() {
    $$('[data-product-form]').forEach(form => {
      const button = $('[data-add-button]', form), variant = variantFor(form);
      if (!button || !variant) return;
      button.disabled = cartBusy || !variant.available;
      labelButton(button, !variant.available ? config.soldLabel : cartBusy && button.hasAttribute('aria-busy') ? 'Adding…' : config.addLabel);
    });
    $$('[data-quick-add] button[type="submit"]').forEach(button => { button.disabled = cartBusy; });
  }
  function setError(form, message) { const el = $('.form-error', form); if (el) el.textContent = message || ''; }
  async function jsonResponse(response) {
    let data;
    try { data = await response.json(); } catch { throw new Error(config.error); }
    if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : config.error);
    return data;
  }
  function cartFocus(dialog, session) {
    if (!dialog?.open || session !== cartSession || !dialog.contains(document.activeElement)) return null;
    const active = document.activeElement;
    return {key: active.closest('[data-line-key]')?.dataset.lineKey,
      control: active.matches('[data-cart-key]') ? 'quantity' : active.matches('[data-cart-remove]') ? 'remove' : 'close'};
  }
  function restoreCartFocus(dialog, session, focus) {
    if (!focus || !dialog?.open || session !== cartSession) return;
    const line = $$('[data-line-key]', dialog).find(el => el.dataset.lineKey === focus.key);
    const candidate = focus.control === 'quantity' ? $('[data-cart-key]', line) : focus.control === 'remove' ? $('[data-cart-remove]', line) : null;
    const target = candidate && !candidate.closest('[hidden]') ? candidate : null;
    (target || $('[data-close-cart]', dialog))?.focus({preventScroll: true});
  }
  function cartPending(pending) {
    const dialog = cartDialog(); if (!dialog) return;
    if (pending) dialog.setAttribute('aria-busy', 'true'); else dialog.removeAttribute('aria-busy');
    $$('[data-cart-key]', dialog).forEach(el => { el.readOnly = pending; });
    $$('[data-cart-remove]', dialog).forEach(el => { if (pending) el.setAttribute('aria-disabled', 'true'); else el.removeAttribute('aria-disabled'); });
    $$('button[name="checkout"]', dialog).forEach(el => { el.disabled = pending; });
  }
  function cartNotice(message) { const el = $('[data-cart-error]', cartDialog()); if (el) el.textContent = message; }
  function unknownCart(session) {
    const dialog = cartDialog(), focus = cartFocus(dialog, session);
    $$('[data-cart-lines], [data-cart-summary], [data-cart-heading-count]', dialog).forEach(el => { el.hidden = true; });
    const recovery = $('[data-cart-recovery]', dialog); if (recovery) recovery.hidden = false;
    $$('[data-cart-count]').forEach(el => { el.textContent = '—'; });
    cartNotice('We could not confirm your bag. Open the full bag to check its latest contents before trying again.');
    restoreCartFocus(dialog, session, focus);
  }
  function renderCart(html, session) {
    if (typeof html !== 'string') throw new Error(config.error);
    const incoming = $('#CartDrawer', new DOMParser().parseFromString(html, 'text/html'));
    const count = Number(incoming?.dataset.cartItemCount), dialog = cartDialog();
    if (!incoming || !dialog || !incoming.hasAttribute('data-cart-item-count') || !Number.isInteger(count) || count < 0) throw new Error(config.error);
    const focus = cartFocus(dialog, session);
    dialog.innerHTML = incoming.innerHTML;
    dialog.dataset.cartItemCount = String(count);
    $$('[data-cart-count]').forEach(el => { el.textContent = String(count); });
    cartPending(cartBusy); restoreCartFocus(dialog, session, focus);
  }
  async function readCart() {
    const url = new URL(config.cart, location.origin); url.searchParams.set('sections', 'cf-cart-drawer');
    const sections = await deadline(signal => fetch(url, {signal, credentials: 'same-origin', cache: 'no-store'}).then(jsonResponse));
    return sections['cf-cart-drawer'];
  }
  async function refreshCart(session) { renderCart(await readCart(), session); }
  function releaseCart() { cartBusy = false; syncButtons(); cartPending(false); }
  async function showCart(trigger) {
    if (cartBusy) return;
    const session = ++cartSession;
    if (!openDialog(cartDialog(), trigger)) { location.assign(config.cart); return; }
    cartBusy = true; syncButtons(); cartPending(true); cartNotice('Updating your bag…');
    try { await refreshCart(session); }
    catch { unknownCart(session); }
    finally { releaseCart(); }
  }
  async function changeCart(key, quantity) {
    if (cartBusy || !Number.isInteger(quantity) || quantity < 0) return;
    const session = cartSession;
    cartBusy = true; syncButtons(); cartPending(true); cartNotice('');
    await changeOnce({
      post: async () => {
        const cart = await deadline(signal => fetch(config.change, {signal, method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify({id: key, quantity, sections: ['cf-cart-drawer'], sections_url: location.pathname})}).then(jsonResponse));
        return cart.sections?.['cf-cart-drawer'];
      },
      read: readCart, apply: html => renderCart(html, session),
      recovered: () => { cartNotice('We checked your bag after an interrupted update. The quantities shown are its current contents.'); announce('Your current bag is shown.'); },
      unknown: () => unknownCart(session),
      confirmed: () => announce('Your bag has been updated.'), settled: releaseCart
    });
  }
  function selectMedia(section, mediaId) {
    const media = $$('.product-media[data-media-id]', section);
    if (!media.some(el => el.dataset.mediaId === String(mediaId))) return;
    media.forEach(el => { el.hidden = el.dataset.mediaId !== String(mediaId); if (el.hidden) $$('video', el).forEach(video => video.pause()); });
    $$('[data-media-target]', section).forEach(el => {
      if (el.dataset.mediaTarget === String(mediaId)) el.setAttribute('aria-current', 'true'); else el.removeAttribute('aria-current');
    });
    const counter = $('[data-gallery-count]', section);
    if (counter) { counter.hidden = media.length < 2; counter.textContent = `${media.findIndex(el => el.dataset.mediaId === String(mediaId)) + 1} / ${media.length}`; }
  }
  function updateVariant(select) {
    const section = select.closest('[data-product-section]'), form = select.closest('form'), variant = variantFor(form);
    if (!variant) return;
    const price = $('[data-main-price]', section); price.textContent = variant.price;
    if (variant.onSale) { const compare = document.createElement('s'); compare.textContent = variant.compare; price.append(' ', compare); }
    const qty = $('[name="quantity"]', form); qty.min = variant.min; qty.step = variant.step;
    if (variant.max != null) qty.max = variant.max; else qty.removeAttribute('max');
    qty.value = variant.min;
    if (variant.media) selectMedia(section, variant.media);
    const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState(history.state, '', url);
    syncButtons(); setError(form, '');
  }
  function hideSearch(restoreFocus = false) {
    clearTimeout(searchTimer); searchController?.abort(); search.invalidate();
    const panel = $('#PredictiveResults'), input = $('[data-predictive-input]');
    if (restoreFocus && panel?.contains(document.activeElement)) input?.focus();
    if (panel) panel.hidden = true;
    input?.setAttribute('aria-expanded', 'false');
  }
  function fitSearch() {
    if (searchFrame) return;
    searchFrame = requestAnimationFrame(() => {
      searchFrame = null;
      const panel = $('#PredictiveResults'); if (!panel || panel.hidden) return;
      const viewport = window.visualViewport;
      const bottom = viewport ? viewport.offsetTop + viewport.height : innerHeight;
      panel.style.setProperty('--predictive-height', `${Math.max(0, bottom - panel.getBoundingClientRect().top - 12)}px`);
    });
  }
  function focusSuggestion(target, panel) {
    target?.focus({preventScroll: true});
    if (!target || !panel.contains(target)) return;
    const item = target.getBoundingClientRect(), bounds = panel.getBoundingClientRect();
    if (item.bottom > bounds.bottom) panel.scrollTop += item.bottom - bounds.bottom + 4;
    else if (item.top < bounds.top) panel.scrollTop -= bounds.top - item.top + 4;
  }
  function closeNavigation(details, restoreFocus) {
    if (restoreFocus && details.contains(document.activeElement)) $('summary', details)?.focus();
    details.open = false;
  }
  function initialize() {
    $$('[data-recommendations]').forEach(container => {
      if (initialized.has(container) || container.querySelector('.product-card')) return;
      initialized.add(container);
      const load = async () => {
        try {
          const response = await fetch(container.dataset.url, {credentials: 'same-origin'});
          if (!response.ok) return;
          const incoming = $('[data-recommendations]', new DOMParser().parseFromString(await response.text(), 'text/html'));
          if (incoming?.querySelector('.product-card')) container.innerHTML = incoming.innerHTML;
        } catch { /* Optional native recommendations do not interrupt shopping. */ }
      };
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); load(); }
        }, {rootMargin: '300px'});
        observer.observe(container);
      } else load();
    });
    $$('[data-gallery]').forEach(gallery => {
      if (initialized.has(gallery)) return;
      initialized.add(gallery);
      const section = gallery.closest('[data-product-section]'), form = $('[data-product-form]', section);
      const media = variantFor(form)?.media || $('.product-media[data-media-id]', gallery)?.dataset.mediaId;
      if (media) selectMedia(section, media);
    });
    syncButtons();
  }
  document.addEventListener('submit', async event => {
    if (cartBusy && event.target.closest('#CartDrawer')) { event.preventDefault(); return; }
    const form = event.target.closest('[data-product-form], [data-quick-add]');
    if (!form || !window.fetch || !dialogSupported || !cartDialog()) return;
    event.preventDefault(); if (cartBusy || !form.checkValidity()) return;
    cartBusy = true; syncButtons(); setError(form, '');
    const button = $('button[type="submit"]', form), quickLabel = $('[data-quick-label]', button);
    const showReceipt = (label, success) => { quickLabel.textContent = label; if (success) button.setAttribute('data-added', 'true'); else button.removeAttribute('data-added'); };
    const receipt = quickLabel ? added.begin(button, showReceipt) : null;
    button?.setAttribute('aria-busy', 'true');
    if (!quickLabel && button) labelButton(button, 'Adding…');
    try {
      await deadline(signal => fetch(config.add, {signal, method: 'POST', body: new FormData(form), credentials: 'same-origin', headers: {Accept: 'application/json'}}).then(jsonResponse));
      if (quickLabel) added.finish(button, receipt, showReceipt, true);
      try { await refreshCart(); cartSession++; openDialog(cartDialog(), button); announce('Added to your bag.'); }
      catch { location.assign(config.cart); }
    } catch (exception) {
      if (quickLabel) added.finish(button, receipt, showReceipt, false);
      setError(form, exception instanceof TypeError ? 'We could not confirm this update. Check your bag before trying again.' : exception.message || config.error);
    } finally { button?.removeAttribute('aria-busy'); releaseCart(); }
  });
  document.addEventListener('click', async event => {
    const openCart = event.target.closest('[data-open-cart]');
    if (openCart && dialogSupported) {
      if (!plainLink(event, openCart)) return;
      event.preventDefault(); await showCart(openCart);
    }
    if (event.target.closest('[data-close-cart]')) closeDialog(cartDialog());
    const remove = event.target.closest('[data-cart-remove]');
    if (remove) { event.preventDefault(); changeCart(remove.dataset.cartRemove, 0); }
    const step = event.target.closest('[data-quantity-step]');
    if (step) {
      if (cartBusy) return;
      const input = $('input', step.closest('.quantity-control'));
      try { Number(step.dataset.quantityStep) < 0 ? input.stepDown() : input.stepUp(); input.dispatchEvent(new Event('change', {bubbles: true})); } catch { input.reportValidity(); }
    }
    const media = event.target.closest('[data-media-target]');
    if (media) { event.preventDefault(); selectMedia(media.closest('[data-product-section]'), media.dataset.mediaTarget); }
    const zoom = event.target.closest('[data-zoom-image]');
    if (zoom && dialogSupported && plainLink(event, zoom)) {
      const section = zoom.closest('[data-product-section]'), source = $('img', zoom.closest('.product-media')), dialog = $('[data-image-dialog]', section), image = $('img', dialog);
      if (source && image && openDialog(dialog, zoom)) { event.preventDefault(); image.src = zoom.href; image.alt = source.alt; }
    }
    if (event.target.closest('[data-close-image]')) closeDialog(event.target.closest('dialog'));
    const filters = event.target.closest('[data-open-filters]');
    if (filters && dialogSupported) {
      const shell = filters.closest('[data-filter-shell]'), dialog = $('[data-filter-dialog]', shell), form = $('form', $('[data-filter-home]', shell));
      if (form) $('[data-filter-target]', dialog).append(form);
      openDialog(dialog, filters);
    }
    if (event.target.closest('[data-close-filters]')) closeDialog(event.target.closest('dialog'));
    if (!event.target.closest('.header-search')) hideSearch();
    $$('.mega[open],.mobile-menu[open]').forEach(details => { if (!details.contains(event.target)) closeNavigation(details, false); });
    if (dialogSupported && event.target instanceof HTMLDialogElement) {
      const bounds = event.target.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) closeDialog(event.target);
    }
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-cart-key]') && event.target.checkValidity()) changeCart(event.target.dataset.cartKey, Number(event.target.value));
    if (event.target.matches('[data-variant-select]')) updateVariant(event.target);
  });
  document.addEventListener('close', event => {
    const dialog = event.target;
    if (!dialogSupported || !(dialog instanceof HTMLDialogElement)) return;
    if (dialog.open) return;
    if (dialog === cartDialog()) {
      cartSession++;
      // Native dialog restores focus. Never override a new focus chosen after closing.
      const active = document.activeElement;
      if (active !== document.body && !dialog.contains(active)) return;
    }
    if (dialog.matches('[data-filter-dialog]')) {
      const shell = dialog.closest('[data-filter-shell]'), form = $('form', dialog);
      if (form) $('[data-filter-home]', shell).append(form);
    }
    const opener = openers.get(dialog); if (opener?.isConnected) opener.focus();
  }, true);
  document.addEventListener('cancel', event => {
    if (dialogSupported && event.target instanceof HTMLDialogElement) { event.preventDefault(); closeDialog(event.target); }
  }, true);
  document.addEventListener('input', event => {
    const input = event.target.closest('[data-predictive-input]'); if (!input) return;
    hideSearch(); const term = input.value.trim(); if (term.length < 2) return;
    const version = search.invalidate();
    searchTimer = setTimeout(async () => {
      searchController = new AbortController();
      const url = new URL(config.predictive, location.origin);
      url.searchParams.set('q', term); url.searchParams.set('resources[type]', 'product'); url.searchParams.set('resources[limit]', '5'); url.searchParams.set('section_id', 'cf-predictive-search');
      try {
        const response = await fetch(url, {signal: searchController.signal, credentials: 'same-origin'}); if (!response.ok) return;
        const html = await response.text(); if (!search.current(version)) return;
        const list = $('.predictive-list', new DOMParser().parseFromString(html, 'text/html')), panel = $('#PredictiveResults');
        if (!panel || !list) return;
        panel.replaceChildren(list);
        if (!$('a', list)) { const empty = document.createElement('p'); empty.className = 'predictive-empty'; empty.textContent = 'No matches yet. Try another word.'; panel.append(empty); }
        const more = document.createElement('a'), target = new URL(config.root + 'search', location.origin);
        target.searchParams.set('q', term); target.searchParams.set('type', 'product'); more.href = target.href; more.className = 'text-link'; more.textContent = 'View all results →'; panel.append(more);
        panel.hidden = false; input.setAttribute('aria-expanded', 'true'); fitSearch();
      } catch (exception) { if (exception.name !== 'AbortError' && search.current(version)) hideSearch(); }
    }, 220);
  });
  document.addEventListener('toggle', event => {
    if (event.target.matches('.mega') && event.target.open) $$('.mega[open]').forEach(other => { if (other !== event.target) closeNavigation(other, false); });
  }, true);
  document.addEventListener('focusout', event => {
    const searchArea = event.target.closest('.header-search');
    if (searchArea && !searchArea.contains(event.relatedTarget)) hideSearch();
    const details = event.target.closest('.mega');
    if (details?.open && event.relatedTarget && !details.contains(event.relatedTarget)) closeNavigation(details, false);
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      hideSearch(true); $$('.mega[open],.mobile-menu[open]').forEach(details => closeNavigation(details, true));
    }
    const mega = event.target.closest('.mega');
    if (mega && ['ArrowDown','ArrowUp','Home','End'].includes(event.key)) {
      const links = $$('.mega-panel a', mega);
      if (links.length) {
        event.preventDefault(); mega.open = true;
        const i = links.indexOf(document.activeElement);
        let next = event.key === 'End' ? links.length - 1 : event.key === 'Home' ? 0 :
          event.key === 'ArrowDown' ? (i + 1) % links.length : (i < 0 ? links.length - 1 : (i - 1 + links.length) % links.length);
        links[next].focus();
      }
    }
    const input = $('[data-predictive-input]'), panel = $('#PredictiveResults');
    if (panel && !panel.hidden && (event.target === input || panel.contains(event.target)) && ['ArrowDown','ArrowUp'].includes(event.key)) {
      const links = $$('a', panel); if (!links.length) return;
      event.preventDefault();
      const next = nextSuggestion(links.indexOf(document.activeElement), links.length, event.key);
      focusSuggestion(next < 0 ? input : links[next], panel);
    }
  });
  window.addEventListener('resize', fitSearch, {passive: true});
  window.addEventListener('scroll', fitSearch, {passive: true});
  window.visualViewport?.addEventListener('resize', fitSearch, {passive: true});
  window.visualViewport?.addEventListener('scroll', fitSearch, {passive: true});
  matchMedia('(min-width: 701px)').addEventListener('change', event => { if (event.matches) $$('[data-filter-dialog][open]').forEach(closeDialog); });
  document.addEventListener('shopify:section:load', initialize);
  initialize();
})();
